import {
  Button, Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay, Text,
} from "@chakra-ui/react";
import React from "react";
import {useRouter} from "next/router";

export const UserRegisterSuccessModal = ({isSuccessOpen, onSuccessClose, isTherapist = false}) => {
  const router = useRouter();

  return (
    <Modal isOpen={isSuccessOpen} onClose={onSuccessClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Welcome to Welldoing!</ModalHeader>

        <ModalBody>
          <Text>
            <p>Thanks for registering with Welldoing.</p>
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button
            mr={3}
            onClick={() => {
              onSuccessClose();
              router.push({
                pathname: `/accounts/${isTherapist ? 'practitioner' : 'user'}-account/dashboard`,
                query: {},
              }, undefined, {shallow: true});
            }}
          >
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
};
